module.exports = __webpack_public_path__ + "static/media/concept.ea532ca8.svg";